import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import DataState from '../../components/DataState';
import { mediaPicture } from '../../data/images';
import { useCollections } from '../../lib/api/collections';

const when = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' }) : '');

export const ProjectCard = ({ project }) => (
  <Link to={`/projects/${project.id}`} className="sc-pcard">
    <div className="sc-pcard__img">
      <img src={mediaPicture(project.imagePath)} alt="" loading="lazy" />
      {project.category && <span className="sc-pcard__tag">{project.category}</span>}
    </div>
    <div className="sc-pcard__body">
      {project.date && <small>{when(project.date)}</small>}
      <h4>{project.title}</h4>
      {project.summary && <p>{project.summary}</p>}
      <span className="sc-pcard__more">Read more &rarr;</span>
    </div>
  </Link>
);

const ProjectsMain = () => {
  const content = useCollections('projects', 'projectCategories');
  const [params, setParams] = useSearchParams();
  if (content.loading || content.error) return <DataState state={content} />;

  const category = params.get('category');
  const used = content.projectCategories.filter((c) => content.projects.some((p) => p.categorySlug === c.slug));
  const list = category ? content.projects.filter((p) => p.categorySlug === category) : content.projects;

  return (
    <main>
      <Breadcrumb title="Projects" subTitle="Projects" />
      <div className="sc-listing pt-120 pb-90">
        <div className="container">
          {used.length > 1 && (
            <div className="sc-pills" role="tablist" aria-label="Project categories">
              <button type="button" className={!category ? 'active' : ''} onClick={() => setParams({})}>All</button>
              {used.map((c) => (
                <button key={c.slug} type="button" className={category === c.slug ? 'active' : ''} onClick={() => setParams({ category: c.slug })}>{c.name}</button>
              ))}
            </div>
          )}
          {list.length === 0 ? (
            <div className="sc-empty-state">
              <h4>Projects will be added soon</h4>
              <p>Research, student and community projects of SANASA Campus will be shown here.</p>
              <Link className="ed-btn-theme" to="/research"><span>See our research</span></Link>
            </div>
          ) : (
            <div className="row">
              {list.map((p) => (
                <div key={p.id} className="col-xl-4 col-lg-4 col-md-6 mb-30">
                  <ProjectCard project={p} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default ProjectsMain;
